webpackJsonp([110308036455227],{

/***/ 140:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n        padding-top: 0;\n    "], ["\n        padding-top: 0;\n    "]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n        height: 500px;\n    "], ["\n        height: 500px;\n    "]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n        height: 400px;\n    "], ["\n        height: 400px;\n    "]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n        height: 235px;\n    "], ["\n        height: 235px;\n    "]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n        flex-direction: column;\n        align-items: center;\n    "], ["\n        flex-direction: column;\n        align-items: center;\n    "]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n            flex: none;\n            width: 360px;\n            max-width: 100%;\n        "], ["\n            flex: none;\n            width: 360px;\n            max-width: 100%;\n        "]),
	    _templateObject7 = _taggedTemplateLiteralLoose(["\n            padding-right: 0;\n        "], ["\n            padding-right: 0;\n        "]),
	    _templateObject8 = _taggedTemplateLiteralLoose(["\n            padding-left: 0;\n        "], ["\n            padding-left: 0;\n        "]),
	    _templateObject9 = _taggedTemplateLiteralLoose(["\n        font-size: 25.5px;\n        line-height: 1;\n        letter-spacing: -0.4px;\n    "], ["\n        font-size: 25.5px;\n        line-height: 1;\n        letter-spacing: -0.4px;\n    "]),
	    _templateObject10 = _taggedTemplateLiteralLoose(["\n        margin-top: 4rem;\n    "], ["\n        margin-top: 4rem;\n    "]),
	    _templateObject11 = _taggedTemplateLiteralLoose(["\n        padding: 6rem 2.5rem;\n    "], ["\n        padding: 6rem 2.5rem;\n    "]),
	    _templateObject12 = _taggedTemplateLiteralLoose(["\n        flex-direction: column;\n        padding: 6rem 40px;\n    "], ["\n        flex-direction: column;\n        padding: 6rem 40px;\n    "]),
	    _templateObject13 = _taggedTemplateLiteralLoose(["\n        font-size: 22px;\n        line-height: 28px;\n    "], ["\n        font-size: 22px;\n        line-height: 28px;\n    "]),
	    _templateObject14 = _taggedTemplateLiteralLoose(["\n        flex: 0 0 auto;\n        padding-right: 0;\n        margin-bottom: 3rem;\n    "], ["\n        flex: 0 0 auto;\n        padding-right: 0;\n        margin-bottom: 3rem;\n    "]),
	    _templateObject15 = _taggedTemplateLiteralLoose(["\n        flex: 0 0 auto;\n    "], ["\n        flex: 0 0 auto;\n    "]),
	    _templateObject16 = _taggedTemplateLiteralLoose(["\n        font-size: 14px;\n    "], ["\n        font-size: 14px;\n    "]);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _lodash = __webpack_require__(27);
	
	var _polished = __webpack_require__(12);
	
	var _components = __webpack_require__(11);
	
	var _arrowBack = __webpack_require__(47);
	
	var _arrowBack2 = _interopRequireDefault(_arrowBack);
	
	var _themes = __webpack_require__(15);
	
	var _global = __webpack_require__(5);
	
	var _type = __webpack_require__(10);
	
	var _utils = __webpack_require__(4);
	
	var _colors = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Project = function (_Component) {
	    _inherits(Project, _Component);
	
	    function Project() {
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Project);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	            data: []
	        }, _this.componentWillMount = function () {
	            var data = _this.props.previewData || _this.props.pathContext;
	
	            _this.setState({
	                data: data
	            });
	        }, _this.renderSections = function () {
	            var data = _this.state.data;
	
	
	            if (data.acf.sections) {
	                return data.acf.sections.map(function (section, i) {
	                    var blocks = section.blocks;
	
	                    if (section.display_section && section.blocks) {
	                        return _react2.default.createElement(_components.Section, {
	                            key: i,
	                            blocks: blocks,
	                            section: section
	                        });
	                    }
	                });
	            }
	        }, _this.renderCredits = function () {
	            var data = _this.state.data;
	
	
	            if (data.acf.credits) {
	                var credits = data.acf.credits.map(function (credit, i) {
	                    return _react2.default.createElement(
	                        Credit,
	                        {
	                            key: i
	                        },
	                        _react2.default.createElement(
	                            Name,
	                            null,
	                            credit.title
	                        ),
	                        _react2.default.createElement(
	                            Val,
	                            null,
	                            credit.value
	                        )
	                    );
	                });
	                return _react2.default.createElement(
	                    Credits,
	                    null,
	                    credits
	                );
	            }
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    Project.prototype.render = function render() {
	        var data = this.state.data;
	
	
	        if (data) {
	            return _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(_components.ScrollProgress, null),
	                _react2.default.createElement(
	                    Wrapper,
	                    null,
	                    _react2.default.createElement(_components.MetaTags, {
	                        title: "Paul Conrad Architects \u2014 Project : " + data.title,
	                        description: data.meta_description ? data.meta_description : ''
	                    }),
	                    _react2.default.createElement(HeroImage, {
	                        image: data.acf.hero_image.sizes.full_width
	                    }),
	                    _react2.default.createElement(
	                        Opening,
	                        null,
	                        _react2.default.createElement(
	                            Left,
	                            null,
	                            _react2.default.createElement(
	                                Title,
	                                null,
	                                data.title
	                            ),
	                            _react2.default.createElement(
	                                Meta,
	                                null,
	                                data.acf.location && _react2.default.createElement(
	                                    Name,
	                                    null,
	                                    data.acf.location
	                                ),
	                                data.acf.dates && _react2.default.createElement(
	                                    Name,
	                                    null,
	                                    data.acf.dates
	                                ),
	                                this.renderCredits()
	                            )
	                        ),
	                        _react2.default.createElement(
	                            Right,
	                            null,
	                            data.acf.short_description && _react2.default.createElement(Description, {
	                                dangerouslySetInnerHTML: { __html: data.acf.short_description }
	                            })
	                        )
	                    ),
	                    this.renderSections(),
	                    _react2.default.createElement(
	                        ContactPrompt,
	                        null,
	                        _react2.default.createElement(
	                            ContactPromptInner,
	                            null,
	                            _react2.default.createElement(
	                                PromptHeading,
	                                null,
	                                "Work With Us"
	                            ),
	                            _react2.default.createElement(
	                                PromptBody,
	                                null,
	                                _react2.default.createElement(
	                                    PromptCopy,
	                                    null,
	                                    "For project enquiries and further information, contact the studio."
	                                ),
	                                _react2.default.createElement(
	                                    PromptButton,
	                                    { to: '/contact' },
	                                    "Get in touch"
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(_components.Footer, {
	                        title: data.title,
	                        pageURL: (0, _utils.isClient)() ? window.location.href : '',
	                        backLink: '/projects',
	                        backLinkText: 'All Projects'
	                    })
	                )
	            );
	        }
	    };
	
	    return Project;
	}(_react.Component);
	
	var Wrapper = _styledComponents2.default.div.withConfig({
	    displayName: "project__Wrapper",
	    componentId: "sc-17pyl8j-0"
	})(["display:flex;flex-direction:column;align-items:center;width:100%;z-index:2;overflow-x:hidden;padding-top:10rem;", ""], _utils.media.phone(_templateObject));
	
	// Hero
	
	var HeroImage = _styledComponents2.default.div.withConfig({
	    displayName: "project__HeroImage",
	    componentId: "sc-17pyl8j-1"
	})(["width:100%;height:600px;margin-bottom:10rem;background-image:url(", ");", " ", " ", " ", ""], function (props) {
	    return props.image;
	}, _global.bgImage, _utils.media.laptop(_templateObject2), _utils.media.tablet(_templateObject3), _utils.media.phone(_templateObject4));
	
	//// project opening
	
	
	// layout
	
	var Left = _styledComponents2.default.div.withConfig({
	    displayName: "project__Left",
	    componentId: "sc-17pyl8j-2"
	})([""]);
	var Right = _styledComponents2.default.div.withConfig({
	    displayName: "project__Right",
	    componentId: "sc-17pyl8j-3"
	})([""]);
	var Opening = _styledComponents2.default.div.withConfig({
	    displayName: "project__Opening",
	    componentId: "sc-17pyl8j-4"
	})(["", ";display:flex;flex-direction:row;margin-bottom:15rem;", " ", ",", "{flex:50%;box-sizing:border-box;", "}", "{padding-right:2.5rem;", "}", "{padding-left:2.5rem;", "}"], _global.innerContainer, _utils.media.tablet(_templateObject5), Left, Right, _utils.media.tablet(_templateObject6), Left, _utils.media.tablet(_templateObject7), Right, _utils.media.tablet(_templateObject8));
	
	// type styles
	
	var Title = _styledComponents2.default.div.withConfig({
	    displayName: "project__Title",
	    componentId: "sc-17pyl8j-5"
	})(["margin-bottom:2rem;font-family:'Scto';font-weight:300;font-size:34px;line-height:40px;letter-spacing:-0.5px;", ""], _utils.media.laptop(_templateObject9));
	
	var Name = _styledComponents2.default.div.withConfig({
	    displayName: "project__Name",
	    componentId: "sc-17pyl8j-6"
	})([""]);
	var Credit = _styledComponents2.default.div.withConfig({
	    displayName: "project__Credit",
	    componentId: "sc-17pyl8j-7"
	})([""]);
	var Val = _styledComponents2.default.div.withConfig({
	    displayName: "project__Val",
	    componentId: "sc-17pyl8j-8"
	})([""]);
	var Credits = _styledComponents2.default.div.withConfig({
	    displayName: "project__Credits",
	    componentId: "sc-17pyl8j-9"
	})([""]);
	
	var Meta = _styledComponents2.default.div.withConfig({
	    displayName: "project__Meta",
	    componentId: "sc-17pyl8j-10"
	})(["*{", ";text-indent:0!important;}> ", " > ", "{margin-top:1rem;> ", "{font-weight:400;}}"], _type.caption, Credits, Credit, Name);
	
	var Description = _styledComponents2.default.div.withConfig({
	    displayName: "project__Description",
	    componentId: "sc-17pyl8j-11"
	})(["", " &,> *{", ";}"], _utils.media.tablet(_templateObject10), _type.paragraph);
	
	// End-of-page contact prompt (ticket #5)
	var ContactPromptInner = _styledComponents2.default.div.withConfig({
	    displayName: "project__ContactPromptInner",
	    componentId: "sc-17pyl8j-12"
	})(["width:100%;max-width:1200px;display:flex;flex-direction:row;align-items:flex-start;padding:8rem 2.5rem;box-sizing:border-box;", " ", ""], _utils.media.laptop(_templateObject11), _utils.media.tablet(_templateObject12));
	
	var PromptHeading = _styledComponents2.default.div.withConfig({
	    displayName: "project__PromptHeading",
	    componentId: "sc-17pyl8j-13"
	})(["flex:0 0 50%;padding-right:6rem;box-sizing:border-box;font-family:'Scto';font-weight:300;font-size:30px;line-height:36px;color:", ";", " ", ""], _colors.grey, _utils.media.laptop(_templateObject13), _utils.media.tablet(_templateObject14));
	
	var PromptBody = _styledComponents2.default.div.withConfig({
	    displayName: "project__PromptBody",
	    componentId: "sc-17pyl8j-14"
	})(["flex:0 0 50%;display:flex;flex-direction:column;align-items:flex-start;box-sizing:border-box;", ""], _utils.media.tablet(_templateObject15));
	
	var PromptCopy = _styledComponents2.default.div.withConfig({
	    displayName: "project__PromptCopy",
	    componentId: "sc-17pyl8j-15"
	})(["", ";color:", ";margin-bottom:2.5rem;max-width:400px;"], _type.paragraph, _colors.grey);
	
	var PromptButton = (0, _styledComponents2.default)(_gatsbyLink2.default).withConfig({
	    displayName: "project__PromptButton",
	    componentId: "sc-17pyl8j-16"
	})(["display:inline-block;background:#F5F4F2;color:", ";font-size:16px;line-height:1;padding:14px 22px;", ";", ""], _colors.grey, _global.hoverState, _utils.media.laptop(_templateObject16));
	
	var ContactPrompt = _styledComponents2.default.div.withConfig({
	    displayName: "project__ContactPrompt",
	    componentId: "sc-17pyl8j-17"
	})(["width:100%;background:transparent;display:flex;justify-content:center;margin-top:10rem;"]);
	
	exports.default = Project;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-project-js-fa63bb2bbcf478afa0fc.js